import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TeamFormPopup from './TeamFormPopup';
import { apiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrgRequest } from '../../../api/organizations/orgSlice';

const TeamActions = ({ member }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const org = useSelector((state) => state.org.org);
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleMemberStatus = async () => {
    const newStatus = !member.is_active;
    const actionText = newStatus ? 'Activating' : 'Deactivating';

    dispatch(showSnackbar({ message: `${actionText}...`, severity: 'info' }));

    apiClient
      .patch(`/organizations/${org?._id}/users/${member?._id}`, {
        is_active: newStatus,
        email: member?.email,
      })
      .then((res) => {
        dispatch(showSnackbar({ message: res.data.message, severity: 'success' }));
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: err.response?.data?.errors?.message || 'Something went wrong!',
            severity: 'error',
          }),
        );
      })
      .finally(() => {
        handleClose();
        dispatch(fetchOrgRequest());
      });
  };

  const onReinvite = async () => {
    dispatch(showSnackbar({ message: 'Reinviting...', severity: 'info' }));
    apiClient
      .post(`/organizations/${org?._id}/users`, member)
      .then((res) => {
        dispatch(showSnackbar({ message: res.data.message, severity: 'success' }));
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: err.response.data.errors.message || 'Something went wrong!',
            severity: 'error',
          }),
        );
      })
      .finally(() => {
        handleClose();
      });
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setOpen(true);
            handleClose();
          }}
        >
          Edit
        </MenuItem>
        <MenuItem onClick={toggleMemberStatus}>{member.is_active ? 'Deactivate' : 'Activate'}</MenuItem>
        {!member.is_verified && <MenuItem onClick={onReinvite}>Reinvite</MenuItem>}
      </Menu>
      <TeamFormPopup open={open} handleClose={() => setOpen(false)} member={member} mode={'edit'} />
    </>
  );
};

export default TeamActions;
